'use strict';

var _slicedToArray = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var Reach = require('./reach');

var internals = {};

exports.keys = function (obj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return options.symbols !== false ? Reflect.ownKeys(obj) : Object.getOwnPropertyNames(obj); // Defaults to true
};

exports.store = function (source, keys) {
  var storage = new Map();

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var value = Reach(source, key);

    if (typeof value === 'object' || typeof value === 'function') {
      storage.set(key, value);
      internals.reachSet(source, key, undefined);
    }
  }

  return storage;
};

exports.restore = function (copy, source, storage) {
  var _iterator = _createForOfIteratorHelper(storage),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      internals.reachSet(copy, key, value);
      internals.reachSet(source, key, value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

internals.reachSet = function (obj, key, value) {
  var path = Array.isArray(key) ? key : key.split('.');
  var ref = obj;

  for (var i = 0; i < path.length; ++i) {
    var segment = path[i];

    if (i + 1 === path.length) {
      ref[segment] = value;
    }

    ref = ref[segment];
  }
};